// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"bf35ec56","329":"bf35ec56","512":"0c0fca49","662":"bf35ec56","711":"bf35ec56"}[chunkId] + ".chunk.css";
};